import axios from 'axios';
import { BASEURL } from '../../config';
import { getAuthToken } from '../../utils/loginHandler';

export default async function getGraphOverviewData(digitalFilter) {
  const url = `${BASEURL}collection/GetDigitalDateWiseDataForOverview`;
  const token = getAuthToken();
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };

  const data = JSON.stringify({
    startDate: digitalFilter.startDate,
    endDate: digitalFilter.endDate,
    crawlerType: digitalFilter.crawlerType,
    dateType: digitalFilter.dateType,
  });

  const config = {
    method: 'post',
    url: url,
    headers: headers,
    data: data,
  };

  try {
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.error(error);
    return { status: false, message: 'some thing wrong' };
  }
}
